import * as core from "dinero.js";
import * as currencies from "@dinero.js/currencies";

export const dinero = {
  core,
  currencies,
};
